export function render ():string {
    return '<hr class="wavy-hr" />'
}
